// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    firebase: {
      apiKey: "AIzaSyAHfWUIc43jUS1_Ps2HIOUQyCrNSWQCWxY",
      authDomain: "delphina-admin.firebaseapp.com",
      databaseURL: "https://delphina-admin.firebaseio.com",
      projectId: "delphina-admin",
      storageBucket: "delphina-admin.appspot.com",
      messagingSenderId: "915703062531",
      appId: "1:915703062531:web:5e749fa5e88f0f3b"
    },
    gapi: {
      clientId: "915703062531-finpqsttvbq4lcbi0b8925i7ab3nnc23.apps.googleusercontent.com",
      apiKey: "KzvMhrWJEmOBDwWOZ88uNsZP",
      hostedDomain: "delphinahomehealth.com"
    }
  };
  
  /*
   * For easier debugging in development mode, you can import the following file
   * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
   *
   * This import should be commented out in production mode because it will have a negative impact
   * on performance if an error is thrown.
   */
  // import 'zone.js/dist/zone-error';  // Included with Angular CLI.
  